import Player from "@vimeo/player";

let els;

const scaleIframes = function () {
    els = document.querySelectorAll("iframe");
    console.log("scaling Iframes");
    for (let i = 0; i < els.length; i += 1) {
        const width = els[i].getAttribute("width");
        const height = els[i].getAttribute("height");
        const ratio = width / height;
        const parentWidth = els[i].parentElement.offsetWidth;

        els[i].style.width = `${parentWidth}px`;
        els[i].style.height = `${parentWidth / ratio}px`;
    }
};
export const iframeEnhancer = function (el) {
    detectVimeoPlayer();
    scaleIframes();
    window.addEventListener("resize", scaleIframes);
    window.addEventListener("async", scaleIframes);
};

const prepareVimeoPlayer = function (iframe) {
    const container = document.createElement("div");
    container.classList.add("vimeo");
    iframe.after(container);
    container.append(iframe);

    const layer = document.createElement("div");
    layer.classList.add("vimeo__layer");

    const buttonContainer = document.createElement("div");
    buttonContainer.classList.add("vimeo__button-container");

    const button = document.createElement("button");
    button.classList.add("vimeo__button");

    const buttonText = document.createElement("div");
    buttonText.classList.add("vimeo__button-text");
    buttonText.innerText = "play";

    button.append(buttonText);
    buttonContainer.append(button);
    container.append(buttonContainer);
    container.append(layer);

    var iframe = document.querySelector("iframe");
    var player = new Player(iframe);

    player.on("play", function () {
        container.classList.add("vimeo--playing");
    });

    player.on("ended", function () {
        container.classList.remove("vimeo--playing");
    });

    player.on("pause", function () {
        container.classList.remove("vimeo--playing");
    });

    button.addEventListener("click", function () {
        player.play();
    });
};

const detectVimeoPlayer = function () {
    els = document.querySelectorAll("iframe");

    els.forEach(function (el) {
        if (el.getAttribute("src").indexOf("vimeo") > -1) {
            // prepareVimeoPlayer(el);
        }
    });
};
